import { render, staticRenderFns } from "./PrivacyFormComponent.vue?vue&type=template&id=164d18dd"
import script from "./PrivacyFormComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyFormComponent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyFormComponent.vue?vue&type=style&index=0&id=164d18dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports